import DemoForm from "@/components/sections/DemoForm";

const HIGHLIGHTS = [
  "Walk-through of the LocateOS dashboard",
  "Mapped to your customers and contracts",
  "Demo of the mobile field app",
  "Live AI risk-scoring and supervisor intelligence",
  "ROI estimate for your team size",
];

export default function Demo() {
  return (
    <section className="section-y relative">
      <div className="absolute inset-0 dot-grid opacity-15 pointer-events-none" />
      <div className="absolute -top-20 right-0 w-[500px] h-[500px] bg-[#FB923C] mix-blend-screen blur-[180px] opacity-25 pointer-events-none" />
      <div className="container-x relative">
        <div className="grid grid-cols-1 lg:grid-cols-[1fr_1.05fr] gap-10 items-start">
          <div className="reveal">
            <div className="text-xs font-mono uppercase tracking-[0.2em] text-[#F97316] mb-3">Request Demo</div>
            <h1 className="font-display font-extrabold text-4xl sm:text-5xl lg:text-6xl text-white tracking-tight">
              See how LocateOS can modernize your locate operations.
            </h1>
            <p className="mt-5 text-lg text-[#94A3B8] leading-relaxed">
              We'll show you the platform, answer your questions, and map it to your specific workflows.
            </p>
            <ul className="mt-8 space-y-3">
              {HIGHLIGHTS.map((h) => (
                <li key={h} className="flex items-start gap-3 text-white/90">
                  <span className="h-2 w-2 rounded-full bg-[#F97316] shrink-0 mt-2" />
                  <span className="text-sm">{h}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="reveal">
            <DemoForm />
          </div>
        </div>
      </div>
    </section>
  );
}
